function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5ac5"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5ac5"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $93cafb67124a3f94$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"ioUUD":"index.f0d37591.js","27W48":"bullet.694e4757.png","3Itwk":"star.f25133ff.png","jrTfb":"gradient.97950419.png","hUg9v":"stars-texture.a284740d.png","ir3mg":"windows.e93d3cb9.jpg","lUvYT":"shoot.80f359de.mp3","6YMBq":"white-guitar.a38ca9c3.png","bqqrH":"white-guitar-mask.448e87f0.png","cKn0n":"damage.c65a10d8.mp3","jPbR1":"player-death.60078a08.mp3","7y8GY":"vandamme_win.ffb4d049.png","1eucj":"vandamme_loose.c2877aab.png","8TQIx":"coin.0a0ffd3d.wav","glL91":"black-guitar.a938cc98.png","k0Qkj":"black-guitar-mask.2b096543.png","afdl3":"ie11.3c5359c3.png","1yhIT":"flash.622d3616.png","lPQLk":"xd.8a07b836.png","f7Wle":"safari.aec4081c.png","lfciU":"rocket.fa0f9bf7.mp3","iSSH4":"boss-death.11f5d55a.mp3","i2BUo":"black-logo.9a081559.svg","m76iD":"click-picto.685b6451.svg","lUfTJ":"darkmoon.681e31ee.png","4zQqU":"guitar-stand.0fb7f057.png","2nxlv":"move-picto.acfb2082.svg","dt0YB":"score.5fea3160.svg","5Ulsu":"sound-picto.314a6a4e.svg","3Btw4":"white-logo.7eb7611e.svg","fKBll":"acdc.9b67a3f8.mp3","6VUa6":"acdc-midi-file.fcdb39b3.mid"}'));


//# sourceMappingURL=index.e6bf1410.js.map
